import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { ActionIcon, Button } from 'shared/ui';
import PrizeIcon from 'shared/ui/assets/icons/prize-icon.svg?react';
import { highrollersModalModel } from '../../model';

export const HighrollersModalButton = () => {
	const { t } = useTranslation();

	const open = useUnit(highrollersModalModel.highrollersSwitcher.enable);

	return (
		<Button
			variant='standard'
			leftSection={
				<ActionIcon
					variant='secondary'
					component='div'
				>
					<PrizeIcon />
				</ActionIcon>
			}
			onClick={open}
		>
			{t('highrollers-modal.button-label')}
		</Button>
	);
};
